import * as React from "react"
import { Link } from "gatsby"
import { FC } from "react"
import * as styles from '../css/button.module.css'

type ButtonProps = {
    link: string,
    text: string
} 

export const Button: FC<ButtonProps>= ({ link, text}) => {
  return (
    <div className="card">
        <Link to={link}>
            <div className={styles.button}>
                {text}
            </div>
        </Link>
    </div>
  )
}

